import React, { Component, ReactNode } from 'react';
import { IBounds, IPosition, IScrollSize } from 'app/components/scroll/ScrollContext';
import OnScroll, { IScrollEvent } from 'app/components/scroll/OnScroll';
import { ExtractProps } from 'app/utils/types';
import { createShallowEqualSelector } from 'app/utils/redux';

export { IScrollEvent };

interface IProps extends Omit<ExtractProps<typeof OnScroll>, 'onScroll'> {
  readonly children: (scroll?: IScrollEvent) => ReactNode;
}

interface IState {
  lastScrollEvent?: IScrollEvent;
}

export default class GetScroll extends Component<IProps, IState> {
  public readonly state: IState = {};
  private mounted = true;

  private eventMemoize = createShallowEqualSelector(
    ({ bounds }: IScrollEvent) => bounds,
    ({ position }: IScrollEvent) => position,
    ({ scrollSize }: IScrollEvent) => scrollSize,
    (bounds: IBounds, position: IPosition, scrollSize: IScrollSize): IScrollEvent => ({ bounds, position, scrollSize }),
  );

  public componentWillUnmount() {
    this.mounted = false;
  }

  public render() {
    const {
      onScroll,
      state: { lastScrollEvent },
      props: { children, ...props },
    } = this;

    return (
      <OnScroll {...props} onScroll={onScroll}>
        {children(lastScrollEvent)}
      </OnScroll>
    );
  }

  private readonly onScroll = (event: IScrollEvent) => {
    if (!this.mounted) {
      return;
    }

    this.setState(({ lastScrollEvent }) => {
      const memoizedEvent = this.eventMemoize(event);
      if (memoizedEvent !== lastScrollEvent) {
        return { lastScrollEvent: memoizedEvent };
      } else {
        return null;
      }
    });
  };
}
